"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var icons = _interopRequireWildcard(require("@meepshop/utils/lib/icons"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/icon.less");

var styles = {
  "root": "meepshop-meep-ui__menu-icon__root",
  "wrap": "meepshop-meep-ui__menu-icon__wrap",
  "LEFT": "meepshop-meep-ui__menu-icon__LEFT",
  "icon": "meepshop-meep-ui__menu-icon__icon",
  "RIGHT": "meepshop-meep-ui__menu-icon__RIGHT",
  "UPON": "meepshop-meep-ui__menu-icon__UPON",
  "BELOW": "meepshop-meep-ui__menu-icon__BELOW"
};

var Icon = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Icon, _React$PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    (0, _classCallCheck2["default"])(this, Icon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Icon, [{
    key: "render",
    value: function render() {
      var _image$scaledSrc, _image$scaledSrc2, _image$scaledSrc3, _image$scaledSrc4;

      var _this$props = this.props,
          iconSize = _this$props.iconSize,
          image = _this$props.image,
          imagePosition = _this$props.imagePosition,
          onClick = _this$props.onClick,
          isModule = _this$props.isModule,
          children = _this$props.children,
          className = _this$props.className;
      var DefaultIcon = (image === null || image === void 0 ? void 0 : image.__typename) !== 'DefaultIcon' ? function () {
        return null;
      } : icons[image.icon || ''];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(styles.root, " ").concat(styles[imagePosition] || '', " ").concat(!isModule ? styles.wrap : '', " ").concat(className)
      }, (image === null || image === void 0 ? void 0 : image.__typename) !== 'DefaultIcon' ? null : /*#__PURE__*/_react["default"].createElement(DefaultIcon, {
        className: styles.icon,
        style: {
          fontSize: "".concat(iconSize, "px")
        },
        onClick: onClick
      }), (image === null || image === void 0 ? void 0 : image.__typename) !== 'Image' ? null : /*#__PURE__*/_react["default"].createElement("img", {
        className: styles.icon,
        style: {
          fontSize: "".concat(iconSize, "px")
        },
        src: (_image$scaledSrc = image.scaledSrc) === null || _image$scaledSrc === void 0 ? void 0 : _image$scaledSrc.w60,
        srcSet: "".concat((_image$scaledSrc2 = image.scaledSrc) === null || _image$scaledSrc2 === void 0 ? void 0 : _image$scaledSrc2.w60, " 1x, ").concat((_image$scaledSrc3 = image.scaledSrc) === null || _image$scaledSrc3 === void 0 ? void 0 : _image$scaledSrc3.w120, " 2x, ").concat((_image$scaledSrc4 = image.scaledSrc) === null || _image$scaledSrc4 === void 0 ? void 0 : _image$scaledSrc4.w240, " 3x"),
        alt: image
      }), imagePosition === 'ONLY' ? null : children);
    }
  }]);
  return Icon;
}(_react["default"].PureComponent);

exports["default"] = Icon;
(0, _defineProperty2["default"])(Icon, "propTypes", {
  /** props */
  iconSize: _propTypes["default"].oneOf([24, 32, 48]),
  onClick: _propTypes["default"].func,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string
});
(0, _defineProperty2["default"])(Icon, "defaultProps", {
  onClick: function onClick() {}
});